import TagManager, { DataLayerArgs } from '@sooro-io/react-gtm-module';

const GTM_ID = import.meta.env.VITE_GTM_ID || '';
const TRACKING_DISABLED = import.meta.env.VITE_GA_TRACKING_DISABLED === 'true';

function init() {
  if (TRACKING_DISABLED || GTM_ID === '') {
    return false;
  }

  const tagManagerArgs = {
    gtmId: GTM_ID,
  };

  TagManager.initialize(tagManagerArgs);
}

function sendEvent(options: DataLayerArgs) {
  TagManager.dataLayer(options);
}

function sendPageView(page: string) {
  TagManager.dataLayer({
    dataLayer: {
      event: 'pageview',
      page,
    },
  });
}

export { init, sendEvent, sendPageView };
